import React from 'react'

import { Step, StepLabel } from '@material-ui/core'

import { StepIcon, Stepper as StepperComponent } from 'components'

import useStyles from './styles'
import { size } from 'lodash'

const Stepper = ({ activeStep, stepLabels }) => {
  const classes = useStyles()

  const truncateLabel = (label) => {
    return size(label) > 19 ? label.slice(0, 18) + '...' : label
  }

  return (
    <StepperComponent activeStep={activeStep}>
      {stepLabels.map((label, index) => {
        const truncatedLabel = truncateLabel(label)

        return (
          <Step
            key={index}
            classes={{
              horizontal: classes.horizontalStep,
            }}
          >
            <StepLabel
              StepIconComponent={StepIcon}
              classes={{ label: classes.stepperLabel }}
            >
              {truncatedLabel}
            </StepLabel>
          </Step>
        )
      })}
    </StepperComponent>
  )
}

export default Stepper
